import { Component, EventEmitter, Input, Output, AfterViewInit, OnDestroy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { UserGroups } from '@shared/models/iuser.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'miq-multiselect-groups',
  templateUrl: './multiselect-groups.component.html',
  styleUrls: ['./multiselect-groups.component.scss'],
  standalone: false,
})
export class MultiSelectGroupsComponent implements AfterViewInit, OnDestroy {
  public groupControl = new UntypedFormControl([]);
  public selectGroups: UserGroups[] = [];
  public isDisabled = true;

  private _userGroupOptions: UserGroups[] = [];
  private _userListedGroups: UserGroups[] = [];

  @Input() set userGroupOptions(value: UserGroups[]) {
    this._userGroupOptions = value;
    this._initGroups();
  }

  get userGroupOptions(): UserGroups[] {
    return this._userGroupOptions;
  }

  @Input() set userListedGroups(value: UserGroups[]) {
    this._userListedGroups = value;
    this._initGroups();
  }

  get userListedGroups(): UserGroups[] {
    return this._userListedGroups;
  }

  @Output() groupChangeEvent = new EventEmitter<UserGroups[]>();
  @Output() saveGroupsEvent = new EventEmitter<UserGroups[]>();
  @Output() closeMenuEvent = new EventEmitter<void>();

  private _initGroups(): void {
    if (this.userGroupOptions && this.userListedGroups) {
      const groups = this.userListedGroups.map(x => x.key);
      const filteredGroups = this.userGroupOptions.filter(group => groups.includes(group.key));
      this.selectGroups = [...filteredGroups];
      this.groupControl.setValue(filteredGroups);
    }
  }

  ngAfterViewInit(): void {
    this.groupControl.valueChanges.pipe(untilDestroyed(this)).subscribe(currentValue => {
      this.groupChangeEvent.emit(currentValue);
    });
  }

  toggleSelection(userGroup: UserGroups) {
    const value = this.groupControl.value;
    if (value.includes(userGroup)) {
      this.groupControl.setValue(value.filter(item => item !== userGroup));
    } else {
      this.groupControl.setValue([...value, userGroup]);
    }
    this.groupControl.markAsDirty();
  }

  saveChanges() {
    this.selectGroups = [...this.groupControl.value];
    this.saveGroupsEvent.emit(this.groupControl.value);
    this.closeMenuEvent.emit();
    this.groupControl.markAsPristine();
  }

  cancelChanges() {
    this.groupControl.setValue([...this.selectGroups]);
    this.groupControl.markAsPristine();
  }

  ngOnDestroy() {
    // Required by untilDestroyed
  }
}
